import styled from 'styled-components';
import { LinkWithQuery } from 'components/Pagination/LinkWithQuery';
import { mediaQuery } from 'components';
import * as Colors from 'constants/colors';

export const CLPProductNavWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-bottom: 1rem;

  ${mediaQuery.medium`
    justify-content: flex-end;
    gap: 1.5rem;
  `}

  /* Page Limit Select Component Styling */
  .page-limit-select > div {
    font-size: 14px;
    text-transform: uppercase;
    width: 7.7rem;
    margin: 0;
  }
`;

export const CLPPaginationWrapper = styled.div`
  color: ${Colors.LIGHT_GRAY} !important;
  font-size: 14px;
  text-transform: uppercase;
  display: flex;
  justify-content: flex-end;
  a[disabled] {
    pointer-events: none;
  }
`;

export const CLPPaginationNavLink = styled(LinkWithQuery)<{ disabled: boolean }>`
  color: ${({ disabled }) => (disabled ? Colors.LIGHT_GRAY : Colors.BLACK)} !important;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  &:hover {
    color: ${({ disabled }) => (disabled ? Colors.LIGHT_GRAY : '')};
  }

  &:first-of-type {
    margin-right: 10px;
  }
`;

export const CLPPageLink = styled(LinkWithQuery)<{ $active: boolean }>`
  padding: 0 2.5px;
  margin-right: 10px;
  color: ${({ $active }) => ($active ? Colors.BLACK : Colors.LIGHT_GRAY)} !important;
  border-bottom: ${({ $active }) => $active && `1px solid ${Colors.LIGHT_GRAY}`} !important;

  ${mediaQuery.medium`
    margin-right: 13px;
  `};
`;

export const CLPLoadMoreContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  margin-bottom: 2rem;
`;
